import {
  BodyText,
  Box,
  List,
  ListItem,
  ListItemContent,
} from "@utilitywarehouse/hearth-react";
import { uuid4 } from "@sentry/utils";
import _ from "lodash";

import { questionContent } from "../pages/About/questions";
import {
  Answers,
  MappedAnswers,
} from "../context/vulnerability/VulnerabilityContext";
import { SummaryDataTest } from "../pages/Summary/constants";

interface QuesionsAnswersLayoutProps {
  mappedAnswers: MappedAnswers;
}

const QuesionsAnswersLayout: React.FC<QuesionsAnswersLayoutProps> = ({
  mappedAnswers,
}) => {
  return (
    <List>
      {Object.entries(mappedAnswers).map(([key, value]) => (
        <>
          {!_.isEmpty(value) ? (
            <ListItem key={uuid4()} style={{ padding: "16px 0" }}>
              <ListItemContent
                heading={
                  questionContent[key as keyof Answers]?.title || value.title
                }
                data-testid={SummaryDataTest.SUMMARY_QUESTION}
                helperText={
                  <Box data-testid={SummaryDataTest.SUMMARY_ANSWER}>
                    {value.summary ? (
                      <BodyText color="secondary">{value.summary}</BodyText>
                    ) : (
                      {
                        ["string"]: (
                          <BodyText color="secondary"> {value} </BodyText>
                        ),
                        ["object"]: (
                          <ul>
                            {Array.isArray(value)
                              ? value.map((answer) => (
                                  <li key={uuid4()} style={{ padding: "8px" }}>
                                    <BodyText color="secondary">
                                      {answer}
                                    </BodyText>
                                  </li>
                                ))
                              : Object.entries(value).map((answer) => (
                                  <li key={uuid4()} style={{ padding: "8px" }}>
                                    <BodyText color="secondary">
                                      {answer as any}
                                    </BodyText>
                                  </li>
                                ))}
                          </ul>
                        ),
                      }[typeof value as "string" | "object"]
                    )}{" "}
                  </Box>
                }
              />
            </ListItem>
          ) : null}
        </>
      ))}
    </List>
  );
};

export default QuesionsAnswersLayout;
